// src/context/UserStatusContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

type UserStatuses = Record<string, string>;

interface UserStatusContextType {
  userStatuses: UserStatuses;
  setUserStatuses: React.Dispatch<React.SetStateAction<UserStatuses>>;
}

const UserStatusContext = createContext<UserStatusContextType | undefined>(
  undefined,
);

export const UserStatusProvider = ({ children }: { children: ReactNode }) => {
  const [userStatuses, setUserStatuses] = useState<UserStatuses>({});
  return (
    <UserStatusContext.Provider value={{ userStatuses, setUserStatuses }}>
      {children}
    </UserStatusContext.Provider>
  );
};

export const useUserStatuses = () => {
  const context = useContext(UserStatusContext);
  if (!context) {
    throw new Error("useUserStatuses must be used within a UserStatusProvider");
  }
  return context;
};
